<template>
  <div class="brand">
    <img src="./brand.png" alt="">
    <span class="content">医点通 (北京) 信息技术有限公司提供技术支持</span>
  </div>
</template>
<script>
    export default{
        data(){
            return {}
        },
        props: {
            iconClass:{
                  type:String
            }
        }
    }
</script>
<style scoped>
.brand{
  height: 90px;
  background: #535353;
  color: #989898;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}
  .content{
    margin-left: 12px;
    font-size: 14px;
  }
</style>



// WEBPACK FOOTER //
// iBrand.vue?1952abdc